
export const firebaseConfig = {
  apiKey: 'AIzaSyBWnReQxB907FOEPnu9Vpo0Cuptqa368NY',
  authDomain: 'trafficapp2020.firebaseapp.com',
  databaseURL: 'https://trafficapp2020.firebaseio.com',
  projectId: 'trafficapp2020',
  storageBucket: 'trafficapp2020.appspot.com',
  messagingSenderId: '421319370603',
  appId: '1:421319370603:web:7e5d0495bbf96a1f060e2e',
  measurementId: 'G-H6G28FSD89'
}



// WEBPACK FOOTER //
// ./src/config.js